import { ActionReducer } from '@ngrx/store';

/**
 * Meta-reducer to clear store state and prevent memory leaks
 * This is critical for long-running sessions where users navigate
 * between different modules (Profiler, Locator, Spatial Modeler)
 */
export function clearStateMetaReducer(reducer: ActionReducer<any>): ActionReducer<any> {
  return function(state, action) {
    // Clear state on logout
    if (action.type === '[Auth] Logout') {
      state = undefined;
    }
    
    // Clear module-specific state when switching domains
    if (action.type === '[Navigation] Clear Previous Module State') {
      const { router, errors, ...rest } = state || {};
      state = { router, errors }; // Keep only router and errors
    }
    
    return reducer(state, action);
  };
}
